import { render, staticRenderFns } from "./ChallengesForm.vue?vue&type=template&id=9b8c6cc2&scoped=true&"
import script from "./ChallengesForm.vue?vue&type=script&lang=ts&"
export * from "./ChallengesForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengesForm.vue?vue&type=style&index=0&id=9b8c6cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c6cc2",
  null
  
)

export default component.exports